module.exports = __webpack_public_path__ + "img/logo_kunte.e7fcf578.jpg";